import React, { useState, useEffect } from "react";
import { ClaseVehiculos } from "./modalClaseVehiculos";

import useTable from "../../useTable";
import axios from "axios";
import { Toasts } from "../../toasts";
import { Dimmer } from "../../spinner";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "idclasevehiculo",
    label: "CODIGO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "codigoordenanza",
    label: "CODIGO SEGUN ORDENANZA",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaClaseVehiculos(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [clasevehiculo, setClaseVehiculo] = useState();
  const [activate, setActivate] = useState(false);
  const [declaWeb, setDeclaWeb] = useState(false);
  const [idusuario] = useState(localStorage.getItem("idusuario"));
  const [ip] = useState(localStorage.getItem("ip"));
  const [mac] = useState(localStorage.getItem("mac"));
 //arreglar // const permiso = JSON.parse(localStorage.getItem("accreptipvehi"));
 const permiso = '111111111';
  const [operacion, setOperacion] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idclasevehiculo
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigoordenanza.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const blanquear = () => {
    setActivate(false);
    setClaseVehiculo();
  };
  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "clasevehiculo";
    let orden = "idclasevehiculo";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
      });
  };
  const seleccionarRegistro = (idclasevehiculo) => {
    let campos = "*";
    let nomtab = "clasevehiculo";
    let nomid = "idclasevehiculo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idclasevehiculo}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idclasevehiculo > 0) {
            setClaseVehiculo(response.data);
            setMostrar5(true);
          }
        }
        setActivate(false);
      })
      .catch(function () {
        setMostrar5(true);
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const seleccionarDeclaWeb = () => {
    let campos = "*";
    let nomtab = "configindustria";
    let orden = "1";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDeclaWeb(response.data[0].declaracionweb);
        }
      })
      .catch(function () {});
  };

  const consultarClaseVehiculos = (ope, id, per) => (event) => {
    event.preventDefault();
    blanquear();
    if (per.toString() === "1") {
      if (ope === 1) {
        setMostrar5(true);
        setOperacion(1);
      } else if (ope === 4) {
        setOperacion(4);
        seleccionarRegistro(id);
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        setOperacion(3);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
            ? "No posee permiso para Editar"
            : ope === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarDeclaWeb();
  }, []);

  const cerrar = () => {
    props.menu();
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  return (
    <section className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Registro Clasificador de Vehiculos</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={cerrar}>
          Salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
            <SearchInput
            placeholder="Buscar"
            onChange={handleSearch}
            />
        </div>
        <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
            onClick={consultarClaseVehiculos(
                1,
                "",
                permiso.toString().substring(1, 2)
            )}
            disabled = {permiso.toString().substring(1,2) !== '1'}
            />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idclasevehiculo} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "30px",
                    }}
                  >
                    {item.idclasevehiculo}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.codigoordenanza}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "60px",
                    }}
                  >
                    {item.descripcion}
                  </td>
                  <td
                    className="align-baseline"
                    align="center"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={consultarClaseVehiculos(
                        4,
                        item.idclasevehiculo,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarClaseVehiculos(
                        2,
                        item.idclasevehiculo,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarClaseVehiculos(
                        3,
                        item.idclasevehiculo,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ClaseVehiculos
        show={mostrar5}
        declaWeb={declaWeb}
        ip={ip}
        mac={mac}
        idusuario={idusuario}
        clasevehiculo={clasevehiculo}
        operacion={operacion}
        onHideRenderizar={seleccionarRegistros}
        onHideCancela={cerrarModalActualizar}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </section>
  );
}
export default TablaClaseVehiculos;
